import React from "react";
import { Box, TextField, IconButton, InputAdornment, alpha, useTheme } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";

const ChatInput = ({ value, onChange, onSend, disabled }) => {
    const theme = useTheme();

    return (
        <Box sx={{ display: "flex", alignItems: "center", borderTop: 1, borderColor: "divider", p: 1, bgcolor: "background.paper" }}>
            <TextField
                fullWidth
                multiline
                maxRows={4}
                variant="outlined"
                size="small"
                placeholder="Введите сообщение..."
                value={value}
                onChange={(e) => onChange(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' && !e.shiftKey) {
                        e.preventDefault();
                        onSend();
                    }
                }}
                disabled={disabled}
                sx={{
                    mr: 1,
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '24px',
                        '&.Mui-focused fieldset': {
                            boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
                        },
                        '&.Mui-disabled': {
                            '& fieldset': { borderColor: 'divider' },
                            backgroundColor: alpha(theme.palette.action.disabledBackground, 0.1),
                        },
                    },
                }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="Отправить сообщение"
                                onClick={onSend}
                                disabled={!value.trim() || disabled}
                                sx={{ borderRadius: '50%', mr: 0.5 }}
                            >
                                <SendIcon />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
        </Box>
    );
};

export default ChatInput;
